import React from 'react';
import {connect} from 'react-redux'
import {Route, Switch, withRouter} from 'react-router-dom'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'

import {clearAlert, clearState} from 'Skelet/src/modules/fetch.action.js'
import AlertBar from 'Skelet/src/components/AlertBar.js'
import Start from './Start.js'
import PageNotFound from 'Skelet/src/components/PageNotFound.js'
import Settings from './Settings.js'
import Items from './Items.js'
import Echo from './Echo.js'
import CoreRoute from './route-containers/CoreRoute.js'
import StartRoute from './route-containers/StartRoute.js'

// @TODO_WHN minify css (automatisch bij builden?)

// @TODO_WHN persistentState
//   (later als remember_me werkt via API, dat toevoegen en dus loshalen van de CLEAR_STATE. losse localStorage item, of dat stukje niet clearen. denk los item, stuk cleaner denk ik.)
//   ik wil eigenlijk dat mensen niet uitgelogd worden, dus wanneer zien ze de remember_me dan eigenlijk? als ze uitloggen moet de token juist ook weggehaald worden..
//   zou wel session_token kunnen laten verlopen na 24 uur, en dat ze dan net als bij Google gewoon op hun naam kunnen klikken om weer in te loggen.
//     denk dat dit dan vooral een feature in React is, die eigenlijk gewoon opnieuw inlogt met enkel de session_token. in localStorage bijhouden wanneer een token ververst moet worden
//     maar dit zou ook zonder user interactie kunnen.. gewoon een interval van 24 uur, of F5, of nieuwe browser sessie (met sessie cookie?)
//   inloggen terwijl je al ingelogd bent zorgt ervoor dat er niets gebeurt.
//     misschien hier net als Google, dat je gewoon je account aanklikt om in te loggen? als je ingelogd ben, ook niet tekstje van "registreren?" tonen.

// @TODO_WHN waarschuwing voor oude/unsupported browsers
//   https://venturebeat.com/2016/01/12/microsoft-ends-support-for-ie8-ie9-ie10-and-windows-8/
//   denk wel gewoon toelaten, maar waarschuwing dat functies misschien niet werken (bijvoorbeeld autoscroll)

class App extends React.Component {

  componentDidUpdate(prevProps) {
    const isLoggingOut = prevProps.session_token && !this.props.session_token
    const isLoggingIn = !prevProps.session_token && this.props.session_token

    if (isLoggingIn) {
      if(this.props.redirectUrl) {
        this.props.push(this.props.redirectUrl);
      } else {
        this.props.push("/");
      }
    } else if (isLoggingOut) {
      this.props.clearState();
      this.props.push("/start");
    }
  }

  render() {
    return (
      <div id="main">
        <Switch>
          <StartRoute exact path="/start" component={Start} />

          <CoreRoute exact path="/settings" component={Settings} />

          <CoreRoute exact path="/" component={Items} />

          <CoreRoute exact path="/echo" component={Echo} />

          <Route path="*" component={PageNotFound} />
        </Switch>
        <AlertBar alert={this.props.alert} clearAlert={this.props.clearAlert} />
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    state_router: state.router, // needed for redirect after login
    session_token: session_token,
    redirectUrl: state.apiData.redirectUrl,
    alert: state.apiData.alert,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
    clearAlert,
    clearState,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/containers/_app.js